__turbopack_context__.v({
  "applicationLoader": "FaqForm-module-scss-module__wBr_tG__applicationLoader",
  "authorization": "FaqForm-module-scss-module__wBr_tG__authorization",
  "checkboxWrapper": "FaqForm-module-scss-module__wBr_tG__checkboxWrapper",
  "commonMargins": "FaqForm-module-scss-module__wBr_tG__commonMargins",
  "emailContainer": "FaqForm-module-scss-module__wBr_tG__emailContainer",
  "error": "FaqForm-module-scss-module__wBr_tG__error",
  "errorMessage": "FaqForm-module-scss-module__wBr_tG__errorMessage",
  "formHeading": "FaqForm-module-scss-module__wBr_tG__formHeading",
  "inputWrapper": "FaqForm-module-scss-module__wBr_tG__inputWrapper",
  "newLeadFormEmail": "FaqForm-module-scss-module__wBr_tG__newLeadFormEmail",
  "newLeadFormEmailFullWidth": "FaqForm-module-scss-module__wBr_tG__newLeadFormEmailFullWidth",
  "newLeadFormFirstName": "FaqForm-module-scss-module__wBr_tG__newLeadFormFirstName",
  "newLeadFormPhone": "FaqForm-module-scss-module__wBr_tG__newLeadFormPhone",
  "newLeadFormWrapper": "FaqForm-module-scss-module__wBr_tG__newLeadFormWrapper",
  "root": "FaqForm-module-scss-module__wBr_tG__root",
  "widthInputbox": "FaqForm-module-scss-module__wBr_tG__widthInputbox",
  "widthInputboxFirstName": "FaqForm-module-scss-module__wBr_tG__widthInputboxFirstName",
});
